// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-square {
  background: white;
  color: var(--ion-color-dark);
  text-align: center;
  padding: var(--ion-margin);
  transition: border-top-color 0.2s linear, border-bottom-color 0.2s linear, border-left-color 0.2s linear, border-right-color 0.2s linear, color 0.2s linear, background-color 0.2s linear;
  border: 0.5px solid #e2dcd5;
  font-weight: normal;
  text-transform: uppercase;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
}
.slot-square.selected {
  color: white;
  font-family: AppFontBold, sans-serif;
  border-color: var(--ion-color-secondary);
  background: var(--ion-color-secondary);
}

.slot-col {
  max-height: 250px;
  overflow: auto;
}

.header-color {
  text-align: center;
  line-height: 17px;
  color: var(--ion-color-black);
  margin: 5px;
  font-size: 14px;
  font-family: AppFontBold, sans-serif;
}

.no-padding {
  padding: 0px !important;
}

.smaller {
  font-size: 15px;
  padding: 12px 0px;
  text-transform: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/components/slots-selector/slots-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,0BAAA;EACA,yLAAA;EAEA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,4CAAA;AAAD;AACC;EACC,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,sCAAA;AACF;;AAEA;EACC,iBAAA;EACA,cAAA;AACD;;AAEA;EACC,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;AACD;;AACA;EACC,uBAAA;AAED;;AAAA;EACC,eAAA;EACA,iBAAA;EACA,qBAAA;AAGD","sourcesContent":[".slot-square {\n\tbackground: white;\n\tcolor: var(--ion-color-dark);\n\ttext-align: center;\n\tpadding: var(--ion-margin);\n\ttransition: border-top-color 0.2s linear, border-bottom-color 0.2s linear, border-left-color 0.2s linear,\n\t\tborder-right-color 0.2s linear, color 0.2s linear, background-color 0.2s linear;\n\tborder: 0.5px solid #e2dcd5;\n\tfont-weight: normal;\n\ttext-transform: uppercase;\n\tmargin-bottom: 4px;\n\tcursor: pointer;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tbox-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);\n\t&.selected {\n\t\tcolor: white;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tborder-color: var(--ion-color-secondary);\n\t\tbackground: var(--ion-color-secondary);\n\t}\n}\n.slot-col {\n\tmax-height: 250px;\n\toverflow: auto;\n}\n\n.header-color {\n\ttext-align: center;\n\tline-height: 17px;\n\tcolor: var(--ion-color-black);\n\tmargin: 5px;\n\tfont-size: 14px;\n\tfont-family: AppFontBold, sans-serif;\n}\n.no-padding {\n\tpadding: 0px !important;\n}\n.smaller {\n\tfont-size: 15px;\n\tpadding: 12px 0px;\n\ttext-transform: unset;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
